export default {
  "content": "<g clip-path=\"url(#clip0_863_5255)\"><path d=\"M20.89 7.471a9 9 0 10-16.68 6l6.22 9.63a1.87 1.87 0 003.15 0l6.23-9.63a9 9 0 001.08-6zM12 14.001a5 5 0 110-10 5 5 0 010 10z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_863_5255\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};